import { useContext } from 'react'

import { ToastContext } from './toastContext'

export const useToastContext = () => {
  const context = useContext(ToastContext)

  if (!context)
    throw new Error(
      'You forgot to wrap your component in <ToastContextProvider>',
    )

  return context
}
